import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getApiBaseUrl } from 'utils/user';
import { ListedUser } from './types';

export const apiUsers = createApi({
  reducerPath: 'usersApi',
  tagTypes: ['User'],
  baseQuery: fetchBaseQuery({
    baseUrl: `${getApiBaseUrl()}/`,
    credentials: 'include',
    prepareHeaders: (headers) => {
      headers.set('X-Client', 'web');
      return headers;
    },
  }),
  endpoints: builder => ({
    getUsers: builder.query<ListedUser[], void>({
      query: () => 'users',
      transformResponse: (data: { users: ListedUser[] }) => data.users,
      transformErrorResponse: (response: { status: string | number }) => response.status,
      providesTags: ['User'],
    }),
  }),
});

export const {
  useGetUsersQuery,
} = apiUsers;
